export enum TimeReportType {
  project = 0,
  deviation = 1,
}
